import { Injectable, Type } from '@angular/core';
import { RateDisplayComponent } from '@change-requests/components';
import { CompensationTypeDisplayComponent } from '@change-requests/components/display-components/compensation-type-display.component';
import { DepartmentDisplayComponent } from '@change-requests/components/display-components/department-display.component';
import { EmploymentTypeDisplayComponent } from '@change-requests/components/display-components/employment-type-display.component';
import { EndDateDisplayComponent } from '@change-requests/components/display-components/end-date-display.component';
import { HoursPerWeekDisplayComponent } from '@change-requests/components/display-components/hours-per-week-display.component';
import { LocationDisplayComponent } from '@change-requests/components/display-components/location-display.component';
import { PositionDisplayComponent } from '@change-requests/components/display-components/position-display.component';
import { ReportsToDisplayComponent } from '@change-requests/components/display-components/reports-to-display.component';
import { StockOptionsDisplayComponent } from '@change-requests/components/display-components/stock-options-display.component';
import { VacationPayDisplayComponent } from '@change-requests/components/display-components/vacation-pay-display.component';
import { DisplayComponentInterface } from '@change-requests/interfaces/display-component.interface';

type FieldComponentMap = {
    [key: string]: Type<DisplayComponentInterface>;
};

@Injectable()
export class DisplayComponentsService {
    private fields: FieldComponentMap = {
        compensation_type: CompensationTypeDisplayComponent,
        department: DepartmentDisplayComponent,
        employment_type: EmploymentTypeDisplayComponent,
        end_date: EndDateDisplayComponent,
        hours_per_week: HoursPerWeekDisplayComponent,
        location: LocationDisplayComponent,
        position: PositionDisplayComponent,
        rate: RateDisplayComponent,
        reports_to: ReportsToDisplayComponent,
        stock_options: StockOptionsDisplayComponent,
        vacation_pay: VacationPayDisplayComponent,
    };

    getComponentClass(fieldKey: string): Type<DisplayComponentInterface> | undefined {
        return this.fields[fieldKey];
    }
}
